import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

export const ChatMessageAudioWave = ({
  fill = 'var(--bgPrimary)',
}: {
  fill?: string;
}) => <Icon name={iconNames.soundWave} fill={fill} />;
